import React from 'react';
import {useSingleTheme} from '../../components/hooks/hooks-mongoDB/useSingleTheme';
import {useArticles} from '../../components/hooks/hooks-mongoDB/useArticles';
import {useParagraphs} from '../../components/hooks/hooks-mongoDB/useParagraphs';
import ThemesScreen from '../../components/modules/pannelli/ThemesScreen';
import {DWHeadLinks} from '../../components/modules/pannelli/HeadLink';
import '../../components/modules/pannelli/themesScreen.scss';

function EsameO() {
    const {theme} = useSingleTheme('tastewines');
    const tastewines_Theme = theme;
    const {articles} = useArticles('tastewines');
    const article = articles.slice(2, 3) || [];
    const articles_EO = article[0]; 
    const {paragraphs} = useParagraphs('tastewines_3');

    return (
        <section>
            {theme && <DWHeadLinks title={tastewines_Theme.tema_titolo} /> }
            <ThemesScreen theme={tastewines_Theme} article={articles_EO} paragraphs={paragraphs}/> 
        </section>
    )
}
export default EsameO;
